<template>
    <div :class="$style.placeholder" />
</template>

<style module>
@keyframes blink {
    0% {
        background-color: var(--white-08);
    }

    38% {
        background-color: var(--white-16);
    }

    50% {
        background-color: var(--white-16);
    }

    88% {
        background-color: var(--white-08);
    }

    100% {
        background-color: var(--white-08);
    }
}

.placeholder {
    width: 100%;
    background-color: var(--white-08);
    animation: blink 1.4s infinite;
}
</style>
